var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M18,1.8,16.2,0,9,7.2,1.8,0,0,1.8,7.2,9,0,16.2,1.8,18,9,10.8,16.2,18,18,16.2,10.8,9Z",
    fill: "#c30019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCloseBtn);
export default __webpack_public_path__ + "static/media/Error_Close_btn.f2623caefa99df65ba79a77fde8026e5.svg";
export { ForwardRef as ReactComponent };